import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface CategoryCardProps {
  image: string;
  /** Pillar name — rendered as a small mono label above the title. */
  tag: string;
  title: string;
  description: string;
  href: string;
  linkLabel: string;
}

const CategoryCard = ({ image, tag, title, description, href, linkLabel }: CategoryCardProps) => {
  return (
    <div className="glass-card flex h-full flex-col overflow-hidden rounded-[2rem]">
      <div className="p-4 pb-0">
        <div className="relative aspect-[16/9] w-full overflow-hidden rounded-[1.5rem] bg-muted">
          <img src={image} alt="" loading="lazy" className="h-full w-full object-cover" />
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-6">
        <p className="font-mono text-eyebrow uppercase text-primary">{tag}</p>
        <h3 className="text-base font-semibold text-foreground">{title}</h3>
        <p className="text-sm leading-relaxed text-muted-foreground">{description}</p>
        <Link
          className="mt-2 inline-flex items-center gap-1.5 self-start text-sm font-medium text-primary transition-colors hover:text-primary-press"
          to={href}
        >
          {linkLabel}
          <ArrowRight className="h-3.5 w-3.5" aria-hidden />
        </Link>
      </div>
    </div>
  );
};

export default CategoryCard;
